import * as tslib_1 from "tslib";
import Message from "src/models/Message";
import { observable, action, computed } from 'mobx';
import UserApi from 'src/services/UserApi';
import AppEvent from 'src/models/AppEvent';
var UserMessages = /** @class */ (function () {
    function UserMessages(userId, users, messages) {
        this.userId = userId;
        this.users = users;
        this.refresh = new AppEvent();
        this.selectedMessageUserId = 0;
        this.messages = messages;
    }
    UserMessages.prototype.send = function (toId, content) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var message, created;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = new Message({
                            id: 0,
                            toId: toId,
                            fromId: this.userId,
                            fromName: '',
                            toName: '',
                            content: content,
                            dateString: '',
                            isReaded: false
                        });
                        return [4 /*yield*/, UserApi.sendMessage(message)];
                    case 1:
                        created = _a.sent();
                        this.messages.push(created);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserMessages.prototype.setReaded = function (message) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserApi.markMessageReaded(message.id)];
                    case 1:
                        _a.sent();
                        message.isReaded = true;
                        this.refresh._fire(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserMessages.prototype.isWrittenByMe = function (message) {
        return message.fromId === this.userId;
    };
    UserMessages.prototype.getUserById = function (userId) {
        return this.users.find(function (i) { return i.id === userId; });
    };
    UserMessages.prototype.unreadedMessagesByUser = function (userId) {
        var _this = this;
        return (this.messageGroups[userId] || [])
            .filter(function (message) { return message.fromId !== _this.userId && !message.isReaded; })
            .length;
    };
    Object.defineProperty(UserMessages.prototype, "unreadedMessages", {
        get: function () {
            var _this = this;
            return this.messages
                .filter(function (message) { return message.fromId !== _this.userId && !message.isReaded; })
                .length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserMessages.prototype, "userIdsFromMessages", {
        get: function () {
            var _this = this;
            if (!this.messages || this.messages.length === 0 || !this.users || this.users.length === 0) {
                return [];
            }
            var set = new Set(this.messages.map(function (i) { return i.fromId === _this.userId ? i.toId : i.fromId; }));
            return Array.from(set.keys());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserMessages.prototype, "messageGroups", {
        get: function () {
            var _this = this;
            var messageGroups = {};
            this.userIdsFromMessages.forEach(function (key) {
                messageGroups[key] = _this.messages.filter(function (i) { return i.fromId === key || i.toId === key; });
            });
            return messageGroups;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserMessages.prototype, "selectedMessageGroup", {
        get: function () {
            return this.messageGroups[this.selectedMessageUserId] || [];
        },
        enumerable: true,
        configurable: true
    });
    UserMessages.prototype.lastActivity = function (userId) {
        var messages = this.messageGroups[userId];
        return messages.sort(function (a, b) { return a.dateString === b.dateString ? 0 : a.dateString > b.dateString ? 1 : -1; })[messages.length - 1].dateString;
    };
    tslib_1.__decorate([
        observable
    ], UserMessages.prototype, "messages", void 0);
    tslib_1.__decorate([
        observable
    ], UserMessages.prototype, "selectedMessageUserId", void 0);
    tslib_1.__decorate([
        action.bound
    ], UserMessages.prototype, "send", null);
    tslib_1.__decorate([
        action.bound
    ], UserMessages.prototype, "setReaded", null);
    tslib_1.__decorate([
        computed
    ], UserMessages.prototype, "unreadedMessages", null);
    tslib_1.__decorate([
        computed
    ], UserMessages.prototype, "userIdsFromMessages", null);
    tslib_1.__decorate([
        computed
    ], UserMessages.prototype, "messageGroups", null);
    tslib_1.__decorate([
        computed
    ], UserMessages.prototype, "selectedMessageGroup", null);
    return UserMessages;
}());
export default UserMessages;



//////////////////
// WEBPACK FOOTER
// ./src/store/UserMessages.ts
// module id = 366
// module chunks = 0